import gql from "graphql-tag";

export const GET_CONTACT = gql`
    query Contact($contactId: ID!){
        contact(contactId: $contactId) {
            contactId
            userId
            contactSalutation
            contactFirstName
            contactMiddleName
            contactLastName
            contactSuffix
            contactNickName
            displayName
            contactLastFirstName
            contactDescription
            contactLinkedinId
            createdAt
            updatedAt
            deleted
            deletedAt
            tagLinks {
                tagId
                tag {
                    tag
                }
            }
            tags {
                tag
            }
            contactAccountPositions {
                location
                title
                startDate
                endDate
                current
                lastConfirmedAt
                positionDescription
                account {
                    accountId
                    accountName
                    displayName
                    accountLinkedinId
                }
            }
        }
    }
`;

export const GET_CONTACT_BY_LINKEDIN_ID = gql`
    query ContactByLinkedinId($contactLinkedinId: ID!){
        contactByLinkedinId(contactLinkedinId: $contactLinkedinId) {
            contactId
            userId
            contactSalutation
            contactFirstName
            contactMiddleName
            contactLastName
            contactSuffix
            contactNickName
            displayName
            contactLastFirstName
            contactDescription
            contactLinkedinId
            createdAt
            updatedAt
            deleted
            deletedAt
            tags {
                tag
            }
            contactAccountPositions {
                location
                title
                startDate
                endDate
                current
                lastConfirmedAt
                positionDescription
                account {
                    accountId
                    accountName
                    displayName
                    accountLinkedinId
                }
            }
        }
    }
`;

// export const GET_CONTACT_OF_PERSON = gql`
//     query ContactOfPerson($personId: ID!){
//         contactOfPerson(personId: $personId) {
//             contactId
//             personId
//             userId
//             contactSalutation
//             contactFirstName
//             contactMiddleName
//             contactLastName
//             contactSuffix
//             contactNickName
//             displayName
//             contactLastFirstName
//             contactDescription
//             contactLinkedinId
//             createdAt
//             updatedAt
//             deleted
//             deletedAt
//             tagLinks {
//                 tagId
//                 tag {
//                     tag
//                 }
//             }
//             tags {
//                 tag
//             }
//         }
//     }
// `;

export const GET_CONTACTS = gql`
    query Contacts($searchStr: String, $filterSQL: String, $limit: Int, $offset: Int, $orderList: [String]){
        contacts(searchStr: $searchStr, filterSQL: $filterSQL, limit: $limit, offset: $offset, orderList: $orderList) {
            count
            rows {
                contactId
                userId
                contactSalutation
                contactFirstName
                contactMiddleName
                contactLastName
                contactSuffix
                contactNickName
                displayName
                contactLastFirstName
                contactDescription
                contactLinkedinId
                createdAt
                updatedAt
                deleted
                deletedAt
                tagLinks {
                    tagId
                    tag {
                        tag
                    }
                }
                tags {
                    tag
                }
                contactAccountPositions {
                    location
                    title
                    startDate
                    endDate
                    current
                    lastConfirmedAt
                    positionDescription
                    account {
                        accountId
                        accountName
                        displayName
                        accountLinkedinId
                    }
                }
            }
        }
    }
`;

export const GET_CONTACTS_NAMES = gql`
    query ContactsNames($searchStr: String, $limit: Int, $offset: Int, $orderList: [String]){
        contactsNames(searchStr: $searchStr, limit: $limit, offset: $offset, orderList: $orderList) {
            contactId
            contactSalutation
            contactFirstName
            contactMiddleName
            contactLastName
            contactSuffix
            contactNickName
            displayName
            contactLastFirstName
            contactLinkedinId
        }
    }
`;

export const GET_CONTACTS_FIND_BY_NAME = gql`
    query ContactsFindByName($name: String, $limit: Int, $offset: Int, $orderList: [String]){
        contactsFindByName(name: $name, limit: $limit, offset: $offset, orderList: $orderList) {
            contactId
            userId
            contactSalutation
            contactFirstName
            contactMiddleName
            contactLastName
            contactSuffix
            contactNickName
            displayName
            contactLastFirstName
            contactDescription
            contactLinkedinId
            createdAt
            updatedAt
            deleted
            deletedAt
            tags {
                tag
            }
            contactAccountPositions {
                location
                title
                startDate
                endDate
                current
                lastConfirmedAt
                positionDescription
                account {
                    accountId
                    accountName
                    displayName
                    accountLinkedinId
                }
            }
        }
    }
`;

export const GET_CONTACTS_EXPORT = gql`
    query ContactsExport($contactIds: [ID!]!){
        contactsExport(contactIds: $contactIds) {
            contactId
            userId
            contactSalutation
            contactFirstName
            contactMiddleName
            contactLastName
            contactSuffix
            contactNickName
            displayName
            contactLastFirstName
            contactDescription
            contactLinkedinId
            createdAt
            updatedAt
            deletedAt
            tags {
                tag
            }
            emailAddresses {
                emailAddressType
                emailAddress
                primary
                optedOut,
                optedOutAt,
            }
            phoneNumbers {
                phoneNumberType
                phoneNumber
                primary
            }
            mailAddresses {
                mailAddressType
                fullAddress
                address1
                address2
                city
                state
                postalCode
                country
                primary
            }
            contactAccountPositions {
                location
                title
                startDate
                endDate
                current
                lastConfirmedAt
                positionDescription
                account {
                    accountId
                    accountName
                    displayName
                    accountLinkedinId
                }
            }
        }
    }
`;

export const CREATE_CONTACT = gql`
    mutation CreateContact($newContact: newContact!) {
        createContact(
            newContact: $newContact
        ) {
            returnCode
            message
            id
            name
        }
    }
`;

export const UPDATE_CONTACT = gql`
    mutation UpdateContact($changedContact: changedContact!) {
        updateContact(
            changedContact: $changedContact
        ) {
            returnCode
            message
            id
            name
        }
    }
`;

export const UPDATE_BULK_LINKEDIN_CONTACTS = gql`
    mutation UpdateBulkLinkedinContacts($linkedinContactList: [linkedinContact!]!) {
        updateBulkLinkedinContacts(
            linkedinContactList: $linkedinContactList
        ) {
            returnCode
            message
        }
    }
`;

export const DELETE_CONTACT = gql`
    mutation DeleteContact($deleteContactId: ID!) {
        deleteContact(
            deleteContactId: $deleteContactId
        ) {
            returnCode
            message
        }
    }
`;

export const DELETE_CONTACTS = gql`
    mutation DeleteContacts($deleteContactIds: [ID!]!) {
        deleteContacts(
            deleteContactIds: $deleteContactIds
        ) {
            returnCode
            message
        }
    }
`;

export const MERGE_CONTACTS = gql`
    mutation MergeContacts($mainContactId: ID!, $mergeContactIds: [ID!]!) {
        mergeContacts(
            mainContactId: $mainContactId,
            mergeContactIds: $mergeContactIds
        ) {
            returnCode
            message
        }
    }
`;


export const GET_KEYWORDS_OF_CONTACT = gql`
    query KeywordsOfContact($contactId: ID!, $searchStr: String, $limit: Int, $orderList: [String]){
        keywordsOfContact(contactId: $contactId, searchStr: $searchStr, limit: $limit, orderList: $orderList) {
            keywordId
            parentType
            parentId
            count
            updatedAt
            keyword {
                keyword
                ignore
            }
        }
    }
`;

// export const GET_POSITIONS_OF_CONTACT = gql`
//     query PositionsOfContact($contactId: ID!, $searchStr: String, $limit: Int, $orderList: [String]){
//         positionsOfContact(contactId: $contactId, searchStr: $searchStr, limit: $limit, orderList: $orderList) {
//             title
//             startDate
//             endDate
//             current
//         }
//     }
// `;

export const ADD_TAGS_TO_CONTACTS = gql`
    mutation AddTagsToContacts($contactIdList: [ID!]!, $tagObjList: [newTag!]!) {
        addTagsToContacts(
            contactIdList: $contactIdList
            tagObjList: $tagObjList
        ) {
            returnCode
            message
        }
    }
`;

export const REMOVE_TAGS_FROM_CONTACTS = gql`
    mutation RemoveTagsFromContacts($contactIdList: [ID!]!, $tagObjList: [newTag!]!) {
        removeTagsFromContacts(
            contactIdList: $contactIdList
            tagObjList: $tagObjList
        ) {
            returnCode
            message
        }
    }
`;

export const SAVE_LINKEDIN_CONTACT_DETAIL = gql`
    mutation SaveLinkedinContactDetail($linkedinContactData: String!) {
        saveLinkedinContactDetail(
            linkedinContactData: $linkedinContactData
        ) {
            returnCode
            message
        }
    }
`;

// saveLinkedinContactDetail(linkedinContactDetail: linkedinContactDetail!): Result!
